export function getCollegeTypes() {
  return ["2-year", "4-year", "less-than-2-year"];
}
